export const CLIENT_VERSION = "v2.1.0dev-build8";
export const SERVER_VERSION = "v1.0.1";
export const SP_VERSION = "DEMO 1.3.3";